import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/products/sinhroperevod/jpg-png/sinhroperevod.png")